// gitleaks:allow
export enum EnvName {
  LOCAL,
  STAGING,
  PRODUCTION,
}

export const getEnvName = () => {
  const domainParts = window.location.hostname.split(".");
  const domainSuffix = domainParts[domainParts.length - 1];
  if (domainSuffix === "ai") {
    return EnvName.PRODUCTION;
  }
  if (domainSuffix === "work" || domainSuffix === "dev") {
    return EnvName.STAGING;
  }
  return EnvName.LOCAL;
};

export const getApiUrl = () => {
  const domainParts = window.location.hostname.split(".");
  const domainSuffix = domainParts[domainParts.length - 1];
  const domainPrefix = domainParts[0];
  if (domainPrefix === "local") {
    return "https://local.slapshot.work:5000/api";
  }

  if (domainSuffix === "ai") {
    return "https://app.slapshot.ai/api";
  }
  if (domainSuffix === "work") {
    return "https://app.slapshot.work/api";
  }
  if (domainSuffix === "dev") {
    return "https://app.hotrock.dev/api";
  }
  return "http://127.0.0.1:5000/api";
};

export const getWebSocketUrl = () => {
  const domainParts = window.location.hostname.split(".");
  const domainSuffix = domainParts[domainParts.length - 1];
  const domainPrefix = domainParts[0];
  if (domainPrefix === "local") {
    return "wss://local.slapshot.work:5000/ws";
  }

  if (domainSuffix === "ai") {
    return "wss://app.slapshot.ai/ws";
  }
  if (domainSuffix === "work") {
    return "wss://app.slapshot.work/ws";
  }
  if (domainSuffix === "dev") {
    return "wss://app.hotrock.dev/ws";
  }
  return "ws://127.0.0.1:5000/ws";
};

export const getStripeKey = () => {
  const domainParts = window.location.hostname.split(".");
  const domainSuffix = domainParts[domainParts.length - 1];
  const domainPrefix = domainParts[0];
  if (domainPrefix === "local") {
    return "";
  }
  if (domainSuffix === "ai") {
    return "pk_live_51Q6wGv05IgJSpBCKP2IAqKhty7yl7yMOckuaZW5IZMqYN1CpQC3owiZ1yCOuVUoWAvgkmmyjMIP5vJYp4owXvnBX00PFaB68TC"; // gitleaks:allow
  }
  if (domainSuffix === "work") {
    return "pk_test_51Q6xdB06JWxXfebWzw2dMNdClQ7sQFfmOQS2OSvhnjHcTZcmJigohZMv66QEyhevAcA2B40bYHtFS6964XTqUdGF00M9ZksCks"; // gitleaks:allow
  }
  return "pk_test_51RjJXK07z8SZfgN5VvBUm2a2SWIaE1Y03xyc217vyog3T5aUtPhaVDwiz5yGQntB4rrY2oNR24SvlO0g2WRQ3Va100AZs7BHsE"; // gitleaks:allow
};

export const getFingerprintKey = () => {
  const domainParts = window.location.hostname.split(".");
  const domainSuffix = domainParts[domainParts.length - 1];
  const domainPrefix = domainParts[0];
  if (domainPrefix === "local") {
    return "bVTImnLzqFvtzzx4WCJB"; // gitleaks:allow
  }
  if (domainSuffix === "ai") {
    return "VcJXypcxOXoFiLBKBdZ1"; // gitleaks:allow
  }
  if (domainSuffix === "work") {
    return "j3hLqtY2tkDq4LCrGfgY"; // gitleaks:allow
  }
  return "bVTImnLzqFvtzzx4WCJB"; // gitleaks:allow
};

// NOTE: this can be used to enable features only locally or in staging, e.g.
// export const FLAG_ENABLE_INVOICES = ENV === EnvName.LOCAL || ENV === EnvName.STAGING;
export const ENV = getEnvName();
export const API_URL = getApiUrl();
export const WEBSOCKET_URL = getWebSocketUrl();

export const SLAPSHOT_EARLY_ACCESS_URL =
  "https://www.slapshot.ai/early-access/";
export const SLAPSHOT_SUPPORT_URL = "https://support.slapshot.ai/en/support";

// IMPORTANT: Must match FILE_CHUNK_SIZE in slapshot/settings.py
export const FILE_CHUNK_SIZE = 10 * 1024 * 1024;
export const MAX_REQUESTS_COUNT = 5;

export const STRIPE_KEY = getStripeKey();

export const FINGERPRINT_API_KEY = getFingerprintKey();
export const FINGERPRINT_REGION = "us";
export const FINGERPRINT_ENDPOINTS =
  ENV !== EnvName.LOCAL ? "https://suv.slapshot.ai" : undefined;
